import { Form } from 'antd';
import BaseModal from 'basic-ui-lib/components/Modal/BaseModal';
import { forwardRef, useImperativeHandle, useState } from 'react';
import styled from 'styled-components';
import { setPageLoading } from 'widgets/PageLoading';
import { toast } from 'react-toastify';
import { getMessageError } from 'services/response';
import InputLarge from 'basic-ui-lib/components/Input/InputLarge';
import mediaApis from 'modules/media/services/apis';
import useGetManageLibrary from 'modules/media/services/hooks/useGetManageLibrary';

export interface AddNewLinkModalRef {
  open: (currentPath: string) => void;
}

interface Props {}

interface FormValues {
  url: string;
  name: string;
}

const AddNewLinkModal = forwardRef<AddNewLinkModalRef, Props>(({}, ref) => {
  const [form] = Form.useForm();
  const [isOpen, setIsOpen] = useState(false);
  const [currentPath, setCurrentPath] = useState('');
  const [, mutate] = useGetManageLibrary(true);

  useImperativeHandle(ref, () => ({
    open: (path: string) => {
      setCurrentPath(path);
      setIsOpen(true);
    },
  }));

  const onClose = () => {
    setIsOpen(false);
    form.resetFields();
  };

  const handleSubmit = () => {
    form.submit();
  };

  const handleFinish = async (values: FormValues) => {
    try {
      setPageLoading(true);
      const res = await mediaApis.createMediaLink({
        urlLink: values.url,
        name: values.name,
        path: currentPath,
      });

      if(res?.data?.data) {
        toast.success('Add link successful');
        mutate(currentPath);
        onClose();
      }
    } catch (error) {
      toast.error(getMessageError(error) || 'Add link failed');
    } finally {
      setPageLoading(false);
    }
  };
  return (
    <BaseModal title='Add Link' isOpen={isOpen} width={1000} onClose={onClose} okText='Continue' onOk={handleSubmit}>
      <Container>
        <Form layout='vertical' form={form} onFinish={handleFinish}>
          <Form.Item name='url' rules={[{ required: true, message: 'Please input URL' }]}>
            <InputLarge placeholder='Enter URL' />
          </Form.Item>
          <Form.Item name='name' rules={[{ required: true, message: 'Please input link name' }]}>
            <InputLarge placeholder='Link Name' />
          </Form.Item>
        </Form>
      </Container>
    </BaseModal>
  );
});

AddNewLinkModal.displayName = 'AddNewLinkModal';
export default AddNewLinkModal;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding: 0 50px;
`;
